@import '~style-sheet-helpers/core.less';
@import (reference) '../../style.module.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@fontSize: 13px;

.checklist-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.tag-pill {
  margin-right: 5px;
}

.single-pill-wrapper {
  align-items: center;
  display: flex;
}

.pill {
  margin-left: 10px;
  max-width: calc(100% - 25px);
}

.order-tag-dropdown-toggler {
  width: 100%;
  padding: 5px;
  height: 32px;

  svg {
    fill: @product-page--dropdown-toggler--icon-color;
  }
}

.order-tag-dropdown {
  width: 100%;
  display: flex;

  .order-tag-dropdown-toggler {
    background: @product-page--dropdown-toggler--background-color;

    :hover {
      background: @product-page--dropdown-toggler--hover--background-color;
    }
  }
}

.general-options {
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 5px 10px 10px;

  > .option {
    padding: 10px 5px 0;
  }

  > Input {
    .input-border-base-style();
  }
}

.is-returnable {
  padding: 10px 0 0 5px;
}

.upc {
  margin-top: 2px;
}

.reporting-category-dropdown {
  font-size: 13px;

  select {
    padding: 5px;
  }
}

.label {
  padding: 10px 0 5px;
  font-size: 14px;
  font-weight: 500;
}

.bundleLabel {
  padding: 0 0 5px;
  font-size: 14px;
  font-weight: 500;
}

.description {
  font-size: 12px;
}

.tags-label {
  margin-top: 6px;
}

.variants {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0 20px;
}

.variants-title {
  padding-bottom: 10px;
  border-bottom: 1px solid @product-page--variants-title--border-color;
}

.variants-wrapper {
  padding: 20px 0;
}

.variants-header,
.variants-item {
  display: grid;
  grid-template-columns: 200px 300px 75px 200px;
  font-size: @fontSize;
  border: 1px solid @product-page--variants--border-color;
  border-bottom: 0;
  > div {
    padding: 5px;
  }
}

.variants-item {
  border-right: 1px solid @product-page--variants--border-color;
  border-left: 1px solid @product-page--variants--border-color;
  &:last-child {
    border-bottom: 1px solid @product-page--variants--border-color;
  }
  &.centered {
    justify-content: center;
  }
}

.variants-header,
.variants-footer {
  background-color: @product-page--variants--background-color;
  font-weight: 500;
}

.variants-footer {
  display: grid;
  grid-template-columns: 200px 300px auto;
  border: 1px solid @product-page--variants--border-color;
  > div {
    padding: 5px;
  }
  &.variant-loading {
    grid-template-columns: 100%;
  }
  .variant-loading-indicator {
    height: 36px;
    width: 36px;
    margin: auto;
  }
}

.variant-active {
  height: 16px;
  width: 16px;
  fill: @product-page--variants--active--fill-color;
}

.add-variant {
  text-align: center;
}

.save-in-place {
  padding: 0 20px;
  font-size: 15px;
}

.sip-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  > button {
    margin-top: 20px;
  }
}

.sip-message {
  margin-top: 20px;
}

.sip-loading {
  height: 44px;
  width: 44px;
  margin: 10px auto;
}

.auto-complete-dropdown {
  min-width: 300px;
  max-width: 300px;
  max-height: 160px;
  overflow: auto;
}

.product-sku {
  color: @product-page--sku--text-color;
  font-weight: 500;
  margin-top: 10px;
}

.modal-body {
  width: 400px;
  padding: 20px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.inherited-pill {
  margin: 6px 5px 6px 0;
}

.tags-list {
  &.empty {
    padding: 10px 0;
    color: @product-page--tags-list--empty--text-color;
  }
}
